module.exports = __webpack_public_path__ + "img/crypto-btc.f92890de.svg";